import React, { useState } from 'react';
import EcourtTab from './EcourtTab';
import HcservicesTab from './HcservicesTab';
import ScigovTab from './ScigovTab';

const NewCourtCases = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedSubTab, setSelectedSubTab] = useState(0);

  const mainTabs = [
    { name: 'Ecourt', key: 'ecourt' },
    { name: 'Hcservices', key: 'hcservices' },
    { name: 'Scigov', key: 'scigov' }
  ];

  const subTabs = [
    { name: 'Keyword based', key: 'keyword' },
    { name: 'Number based', key: 'number' }
  ];

  // Initialize tab components
  const ecourtTab = EcourtTab();
  const hcservicesTab = HcservicesTab();
  const scigovTab = ScigovTab();

  const renderTabContent = () => {
    if (selectedTab === 0) { // Ecourt
      return selectedSubTab === 0 ? ecourtTab.renderKeywordTab() : ecourtTab.renderNumberTab();
    } else if (selectedTab === 1) { // Hcservices
      return selectedSubTab === 0 ? hcservicesTab.renderKeywordTab() : hcservicesTab.renderNumberTab();
    } else if (selectedTab === 2) { // Scigov
      return selectedSubTab === 0 ? scigovTab.renderKeywordTab() : scigovTab.renderNumberTab();
    }
    return null;
  };

  const renderModals = () => {
    return (
      <>
        {/* Ecourt Modals */}
        {ecourtTab.showNewSettingForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Add Setting</h3>
              </div>
              <form onSubmit={ecourtTab.handleAddSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Keywords *
                  </label>
                  <input
                    type="text"
                    value={ecourtTab.newSetting.keywords}
                    onChange={(e) => ecourtTab.setNewSetting({...ecourtTab.newSetting, keywords: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      ecourtTab.formErrors.keywords ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter keywords (comma separated)"
                  />
                  {ecourtTab.formErrors.keywords && (
                    <p className="text-red-500 text-sm mt-1">{ecourtTab.formErrors.keywords}</p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Start Year *
                    </label>
                    <input
                      type="number"
                      value={ecourtTab.newSetting.startYear}
                      onChange={(e) => ecourtTab.setNewSetting({...ecourtTab.newSetting, startYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        ecourtTab.formErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      End Year *
                    </label>
                    <input
                      type="number"
                      value={ecourtTab.newSetting.endYear}
                      onChange={(e) => ecourtTab.setNewSetting({...ecourtTab.newSetting, endYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        ecourtTab.formErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                </div>
                {ecourtTab.formErrors.yearRange && (
                  <p className="text-red-500 text-sm">{ecourtTab.formErrors.yearRange}</p>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Locations *
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={ecourtTab.locationSearchTerm}
                      onChange={(e) => {
                        ecourtTab.handleLocationSearch(e.target.value);
                        ecourtTab.setShowLocationDropdown(true);
                      }}
                      onFocus={() => ecourtTab.setShowLocationDropdown(true)}
                      placeholder={ecourtTab.locationLoading ? "Loading locations..." : "Search locations..."}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        ecourtTab.formErrors.locations ? 'border-red-500' : ''
                      }`}
                      disabled={ecourtTab.locationLoading}
                    />
                    {ecourtTab.locationLoading && (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                      </div>
                    )}
                    {ecourtTab.showLocationDropdown && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                        {ecourtTab.locationLoading ? (
                          <div className="px-3 py-4 text-center">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto mb-2"></div>
                            <p className="text-sm text-gray-600">Searching locations...</p>
                          </div>
                        ) : ecourtTab.filteredLocations.length === 0 ? (
                          <div className="px-3 py-2 text-gray-500 text-sm">
                            {ecourtTab.locationSearchTerm ? 'No locations found' : 'Type to search locations'}
                          </div>
                        ) : (
                          <>
                            <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
                              {ecourtTab.filteredLocations.length} location{ecourtTab.filteredLocations.length !== 1 ? 's' : ''} found
                            </div>
                            {ecourtTab.filteredLocations.slice(0, 50).map((location) => (
                              <div
                                key={location.value}
                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                onClick={() => ecourtTab.handleLocationSelect(location)}
                              >
                                <div className="text-sm">{location.text}</div>
                              </div>
                            ))}
                            {ecourtTab.filteredLocations.length > 50 && (
                              <div className="px-3 py-2 text-xs text-gray-500 border-t border-gray-100">
                                Showing first 50 results. Refine your search for more specific results.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  {ecourtTab.formErrors.locations && (
                    <p className="text-red-500 text-sm mt-1">{ecourtTab.formErrors.locations}</p>
                  )}

                  {/* Selected Locations */}
                  {ecourtTab.selectedLocations.length > 0 && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-600 mb-2">Selected Locations:</p>
                      <div className="flex flex-wrap gap-2">
                        {ecourtTab.selectedLocations.map((location, index) => (
                          <span
                            key={index}
                            className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                          >
                            {location.text}
                            <button
                              type="button"
                              onClick={() => ecourtTab.handleLocationRemove(location)}
                              className="ml-1 text-blue-600 hover:text-blue-800"
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      ecourtTab.setShowNewSettingForm(false);
                      ecourtTab.setNewSetting({
                        keywords: '',
                        startYear: new Date().getFullYear(),
                        endYear: new Date().getFullYear() + 1,
                        locations: []
                      });
                      ecourtTab.setSelectedLocations([]);
                      ecourtTab.setFormErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={ecourtTab.submitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {ecourtTab.submitting ? 'Adding...' : 'Add Setting'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Hcservices Modals */}
        {hcservicesTab.showHcservicesSettingForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Add Hcservices Setting</h3>
              </div>
              <form onSubmit={hcservicesTab.handleAddHcservicesSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Keywords *
                  </label>
                  <input
                    type="text"
                    value={hcservicesTab.newHcservicesSetting.keywords}
                    onChange={(e) => hcservicesTab.setNewHcservicesSetting({...hcservicesTab.newHcservicesSetting, keywords: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      hcservicesTab.hcservicesFormErrors.keywords ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter keywords (comma separated)"
                  />
                  {hcservicesTab.hcservicesFormErrors.keywords && (
                    <p className="text-red-500 text-sm mt-1">{hcservicesTab.hcservicesFormErrors.keywords}</p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Start Year *
                    </label>
                    <input
                      type="number"
                      value={hcservicesTab.newHcservicesSetting.startYear}
                      onChange={(e) => hcservicesTab.setNewHcservicesSetting({...hcservicesTab.newHcservicesSetting, startYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        hcservicesTab.hcservicesFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      End Year *
                    </label>
                    <input
                      type="number"
                      value={hcservicesTab.newHcservicesSetting.endYear}
                      onChange={(e) => hcservicesTab.setNewHcservicesSetting({...hcservicesTab.newHcservicesSetting, endYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        hcservicesTab.hcservicesFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                </div>
                {hcservicesTab.hcservicesFormErrors.yearRange && (
                  <p className="text-red-500 text-sm">{hcservicesTab.hcservicesFormErrors.yearRange}</p>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Locations *
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={hcservicesTab.hcservicesLocationSearchTerm}
                      onChange={(e) => {
                        hcservicesTab.handleHcservicesLocationSearch(e.target.value);
                        hcservicesTab.setShowLocationDropdown(true);
                      }}
                      onFocus={() => hcservicesTab.setShowLocationDropdown(true)}
                      placeholder={hcservicesTab.hcservicesLocationLoading ? "Loading locations..." : "Search locations..."}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        hcservicesTab.hcservicesFormErrors.locations ? 'border-red-500' : ''
                      }`}
                      disabled={hcservicesTab.hcservicesLocationLoading}
                    />
                    {hcservicesTab.hcservicesLocationLoading && (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                      </div>
                    )}
                    {hcservicesTab.showLocationDropdown && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                        {hcservicesTab.hcservicesLocationLoading ? (
                          <div className="px-3 py-4 text-center">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto mb-2"></div>
                            <p className="text-sm text-gray-600">Searching locations...</p>
                          </div>
                        ) : hcservicesTab.hcservicesFilteredLocations.length === 0 ? (
                          <div className="px-3 py-2 text-gray-500 text-sm">
                            {hcservicesTab.hcservicesLocationSearchTerm ? 'No locations found' : 'Type to search locations'}
                          </div>
                        ) : (
                          <>
                            <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
                              {hcservicesTab.hcservicesFilteredLocations.length} location{hcservicesTab.hcservicesFilteredLocations.length !== 1 ? 's' : ''} found
                            </div>
                            {hcservicesTab.hcservicesFilteredLocations.slice(0, 50).map((location) => (
                              <div
                                key={location.value}
                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                onClick={() => hcservicesTab.handleLocationSelect(location)}
                              >
                                <div className="text-sm">{location.text}</div>
                              </div>
                            ))}
                            {hcservicesTab.hcservicesFilteredLocations.length > 50 && (
                              <div className="px-3 py-2 text-xs text-gray-500 border-t border-gray-100">
                                Showing first 50 results. Refine your search for more specific results.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  {hcservicesTab.hcservicesFormErrors.locations && (
                    <p className="text-red-500 text-sm mt-1">{hcservicesTab.hcservicesFormErrors.locations}</p>
                  )}

                  {/* Selected Locations */}
                  {hcservicesTab.selectedLocations.length > 0 && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-600 mb-2">Selected Locations:</p>
                      <div className="flex flex-wrap gap-2">
                        {hcservicesTab.selectedLocations.map((location, index) => (
                          <span
                            key={index}
                            className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                          >
                            {location.text}
                            <button
                              type="button"
                              onClick={() => hcservicesTab.handleHcservicesLocationRemove(index)}
                              className="ml-1 text-blue-600 hover:text-blue-800"
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      hcservicesTab.setShowHcservicesSettingForm(false);
                      hcservicesTab.setNewHcservicesSetting({
                        keywords: '',
                        startYear: new Date().getFullYear(),
                        endYear: new Date().getFullYear() + 1,
                        locations: []
                      });
                      hcservicesTab.setSelectedLocations([]);
                      hcservicesTab.setHcservicesFormErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={hcservicesTab.hcservicesSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {hcservicesTab.hcservicesSubmitting ? 'Adding...' : 'Add Setting'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Scigov Modals */}
        {scigovTab.showScigovSettingForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Add Scigov Setting</h3>
              </div>
              <form onSubmit={scigovTab.handleAddScigovSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Party Name *
                  </label>
                  <input
                    type="text"
                    value={scigovTab.newScigovSetting.partyName}
                    onChange={(e) => scigovTab.setNewScigovSetting({...scigovTab.newScigovSetting, partyName: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      scigovTab.scigovFormErrors.partyName ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter party name"
                  />
                  {scigovTab.scigovFormErrors.partyName && (
                    <p className="text-red-500 text-sm mt-1">{scigovTab.scigovFormErrors.partyName}</p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Start Year *
                    </label>
                    <input
                      type="number"
                      value={scigovTab.newScigovSetting.startYear}
                      onChange={(e) => scigovTab.setNewScigovSetting({...scigovTab.newScigovSetting, startYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        scigovTab.scigovFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      End Year *
                    </label>
                    <input
                      type="number"
                      value={scigovTab.newScigovSetting.endYear}
                      onChange={(e) => scigovTab.setNewScigovSetting({...scigovTab.newScigovSetting, endYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        scigovTab.scigovFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                </div>
                {scigovTab.scigovFormErrors.yearRange && (
                  <p className="text-red-500 text-sm">{scigovTab.scigovFormErrors.yearRange}</p>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Case Status *
                  </label>
                  <select
                    value={scigovTab.newScigovSetting.status}
                    onChange={(e) => scigovTab.setNewScigovSetting({...scigovTab.newScigovSetting, status: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      scigovTab.scigovFormErrors.status ? 'border-red-500' : ''
                    }`}
                  >
                    <option value="">Select Case Status</option>
                    {scigovTab.scigovStatusOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {scigovTab.scigovFormErrors.status && (
                    <p className="text-red-500 text-sm mt-1">{scigovTab.scigovFormErrors.status}</p>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      scigovTab.setShowScigovSettingForm(false);
                      scigovTab.setNewScigovSetting({
                        partyName: '',
                        startYear: new Date().getFullYear(),
                        endYear: new Date().getFullYear() + 1,
                        status: ''
                      });
                      scigovTab.setScigovFormErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={scigovTab.scigovSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {scigovTab.scigovSubmitting ? 'Adding...' : 'Add Setting'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Edit Modals */}
        {/* Ecourt Edit Setting Form Modal */}
        {ecourtTab.showEditForm && ecourtTab.editingSetting && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Edit Setting</h3>
              </div>
              <form onSubmit={ecourtTab.handleEditSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Keywords *
                  </label>
                  <input
                    type="text"
                    value={ecourtTab.editingSetting.keywords}
                    onChange={(e) => ecourtTab.setEditingSetting({...ecourtTab.editingSetting, keywords: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      ecourtTab.formErrors.keywords ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter keywords (comma separated)"
                  />
                  {ecourtTab.formErrors.keywords && (
                    <p className="text-red-500 text-sm mt-1">{ecourtTab.formErrors.keywords}</p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Start Year *
                    </label>
                    <input
                      type="number"
                      value={ecourtTab.editingSetting.startYear}
                      onChange={(e) => ecourtTab.setEditingSetting({...ecourtTab.editingSetting, startYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        ecourtTab.formErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      End Year *
                    </label>
                    <input
                      type="number"
                      value={ecourtTab.editingSetting.endYear}
                      onChange={(e) => ecourtTab.setEditingSetting({...ecourtTab.editingSetting, endYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        ecourtTab.formErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                </div>
                {ecourtTab.formErrors.yearRange && (
                  <p className="text-red-500 text-sm">{ecourtTab.formErrors.yearRange}</p>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Locations *
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={ecourtTab.locationSearchTerm}
                      onChange={(e) => {
                        ecourtTab.handleLocationSearch(e.target.value);
                        ecourtTab.setShowLocationDropdown(true);
                      }}
                      onFocus={() => ecourtTab.setShowLocationDropdown(true)}
                      placeholder={ecourtTab.locationLoading ? "Loading locations..." : "Search locations..."}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        ecourtTab.formErrors.locations ? 'border-red-500' : ''
                      }`}
                      disabled={ecourtTab.locationLoading}
                    />
                    {ecourtTab.locationLoading && (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                      </div>
                    )}
                    {ecourtTab.showLocationDropdown && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                        {ecourtTab.locationLoading ? (
                          <div className="px-3 py-4 text-center">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto mb-2"></div>
                            <p className="text-sm text-gray-600">Searching locations...</p>
                          </div>
                        ) : ecourtTab.filteredLocations.length === 0 ? (
                          <div className="px-3 py-2 text-gray-500 text-sm">
                            {ecourtTab.locationSearchTerm ? 'No locations found' : 'Type to search locations'}
                          </div>
                        ) : (
                          <>
                            <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
                              {ecourtTab.filteredLocations.length} location{ecourtTab.filteredLocations.length !== 1 ? 's' : ''} found
                            </div>
                            {ecourtTab.filteredLocations.slice(0, 50).map((location) => (
                              <div
                                key={location.value}
                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                onClick={() => ecourtTab.handleLocationSelect(location)}
                              >
                                <div className="text-sm">{location.text}</div>
                              </div>
                            ))}
                            {ecourtTab.filteredLocations.length > 50 && (
                              <div className="px-3 py-2 text-xs text-gray-500 border-t border-gray-100">
                                Showing first 50 results. Refine your search for more specific results.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  {ecourtTab.formErrors.locations && (
                    <p className="text-red-500 text-sm mt-1">{ecourtTab.formErrors.locations}</p>
                  )}

                  {/* Selected Locations */}
                  {ecourtTab.selectedLocations.length > 0 && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-600 mb-2">Selected Locations:</p>
                      <div className="flex flex-wrap gap-2">
                        {ecourtTab.selectedLocations.map((location, index) => (
                          <span
                            key={index}
                            className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                          >
                            {location.text}
                            <button
                              type="button"
                              onClick={() => ecourtTab.handleLocationRemove(location)}
                              className="ml-1 text-blue-600 hover:text-blue-800"
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      ecourtTab.setShowEditForm(false);
                      ecourtTab.setEditingSetting(null);
                      ecourtTab.setSelectedLocations([]);
                      ecourtTab.setFormErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={ecourtTab.submitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {ecourtTab.submitting ? 'Updating...' : 'Update Setting'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Hcservices Edit Setting Form Modal */}
        {hcservicesTab.showHcservicesEditForm && hcservicesTab.editingHcservicesSetting && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Edit Hcservices Setting</h3>
              </div>
              <form onSubmit={hcservicesTab.handleEditHcservicesSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Keywords *
                  </label>
                  <input
                    type="text"
                    value={hcservicesTab.editingHcservicesSetting.keywords}
                    onChange={(e) => hcservicesTab.setEditingHcservicesSetting({...hcservicesTab.editingHcservicesSetting, keywords: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      hcservicesTab.hcservicesFormErrors.keywords ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter keywords (comma separated)"
                  />
                  {hcservicesTab.hcservicesFormErrors.keywords && (
                    <p className="text-red-500 text-sm mt-1">{hcservicesTab.hcservicesFormErrors.keywords}</p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Start Year *
                    </label>
                    <input
                      type="number"
                      value={hcservicesTab.editingHcservicesSetting.startYear}
                      onChange={(e) => hcservicesTab.setEditingHcservicesSetting({...hcservicesTab.editingHcservicesSetting, startYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        hcservicesTab.hcservicesFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      End Year *
                    </label>
                    <input
                      type="number"
                      value={hcservicesTab.editingHcservicesSetting.endYear}
                      onChange={(e) => hcservicesTab.setEditingHcservicesSetting({...hcservicesTab.editingHcservicesSetting, endYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        hcservicesTab.hcservicesFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                </div>
                {hcservicesTab.hcservicesFormErrors.yearRange && (
                  <p className="text-red-500 text-sm">{hcservicesTab.hcservicesFormErrors.yearRange}</p>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Locations *
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={hcservicesTab.hcservicesLocationSearchTerm}
                      onChange={(e) => {
                        hcservicesTab.handleHcservicesLocationSearch(e.target.value);
                        hcservicesTab.setShowLocationDropdown(true);
                      }}
                      onFocus={() => hcservicesTab.setShowLocationDropdown(true)}
                      placeholder={hcservicesTab.hcservicesLocationLoading ? "Loading locations..." : "Search locations..."}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        hcservicesTab.hcservicesFormErrors.locations ? 'border-red-500' : ''
                      }`}
                      disabled={hcservicesTab.hcservicesLocationLoading}
                    />
                    {hcservicesTab.hcservicesLocationLoading && (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                      </div>
                    )}
                    {hcservicesTab.showLocationDropdown && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                        {hcservicesTab.hcservicesLocationLoading ? (
                          <div className="px-3 py-4 text-center">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto mb-2"></div>
                            <p className="text-sm text-gray-600">Searching locations...</p>
                          </div>
                        ) : hcservicesTab.hcservicesFilteredLocations.length === 0 ? (
                          <div className="px-3 py-2 text-gray-500 text-sm">
                            {hcservicesTab.hcservicesLocationSearchTerm ? 'No locations found' : 'Type to search locations'}
                          </div>
                        ) : (
                          <>
                            <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
                              {hcservicesTab.hcservicesFilteredLocations.length} location{hcservicesTab.hcservicesFilteredLocations.length !== 1 ? 's' : ''} found
                            </div>
                            {hcservicesTab.hcservicesFilteredLocations.slice(0, 50).map((location) => (
                              <div
                                key={location.value}
                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                onClick={() => hcservicesTab.handleLocationSelect(location)}
                              >
                                <div className="text-sm">{location.text}</div>
                              </div>
                            ))}
                            {hcservicesTab.hcservicesFilteredLocations.length > 50 && (
                              <div className="px-3 py-2 text-xs text-gray-500 border-t border-gray-100">
                                Showing first 50 results. Refine your search for more specific results.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  {hcservicesTab.hcservicesFormErrors.locations && (
                    <p className="text-red-500 text-sm mt-1">{hcservicesTab.hcservicesFormErrors.locations}</p>
                  )}

                  {/* Selected Locations */}
                  {hcservicesTab.selectedLocations.length > 0 && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-600 mb-2">Selected Locations:</p>
                      <div className="flex flex-wrap gap-2">
                        {hcservicesTab.selectedLocations.map((location, index) => (
                          <span
                            key={index}
                            className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                          >
                            {location.text}
                            <button
                              type="button"
                              onClick={() => hcservicesTab.handleHcservicesLocationRemove(index)}
                              className="ml-1 text-blue-600 hover:text-blue-800"
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      hcservicesTab.setShowHcservicesEditForm(false);
                      hcservicesTab.setEditingHcservicesSetting(null);
                      hcservicesTab.setSelectedLocations([]);
                      hcservicesTab.setHcservicesFormErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={hcservicesTab.hcservicesSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {hcservicesTab.hcservicesSubmitting ? 'Updating...' : 'Update Setting'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Scigov Edit Setting Form Modal */}
        {scigovTab.showScigovEditForm && scigovTab.editingScigovSetting && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Edit Scigov Setting</h3>
              </div>
              <form onSubmit={scigovTab.handleEditScigovSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Party Name *
                  </label>
                  <input
                    type="text"
                    value={scigovTab.editingScigovSetting.partyName}
                    onChange={(e) => scigovTab.setEditingScigovSetting({...scigovTab.editingScigovSetting, partyName: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      scigovTab.scigovFormErrors.partyName ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter party name"
                  />
                  {scigovTab.scigovFormErrors.partyName && (
                    <p className="text-red-500 text-sm mt-1">{scigovTab.scigovFormErrors.partyName}</p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Start Year *
                    </label>
                    <input
                      type="number"
                      value={scigovTab.editingScigovSetting.startYear}
                      onChange={(e) => scigovTab.setEditingScigovSetting({...scigovTab.editingScigovSetting, startYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        scigovTab.scigovFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      End Year *
                    </label>
                    <input
                      type="number"
                      value={scigovTab.editingScigovSetting.endYear}
                      onChange={(e) => scigovTab.setEditingScigovSetting({...scigovTab.editingScigovSetting, endYear: parseInt(e.target.value)})}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        scigovTab.scigovFormErrors.yearRange ? 'border-red-500' : ''
                      }`}
                      min="1900"
                      max="2100"
                    />
                  </div>
                </div>
                {scigovTab.scigovFormErrors.yearRange && (
                  <p className="text-red-500 text-sm">{scigovTab.scigovFormErrors.yearRange}</p>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Case Status *
                  </label>
                  <select
                    value={scigovTab.editingScigovSetting.status}
                    onChange={(e) => scigovTab.setEditingScigovSetting({...scigovTab.editingScigovSetting, status: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      scigovTab.scigovFormErrors.status ? 'border-red-500' : ''
                    }`}
                  >
                    <option value="">Select Case Status</option>
                    {scigovTab.scigovStatusOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {scigovTab.scigovFormErrors.status && (
                    <p className="text-red-500 text-sm mt-1">{scigovTab.scigovFormErrors.status}</p>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      scigovTab.setShowScigovEditForm(false);
                      scigovTab.setEditingScigovSetting(null);
                      scigovTab.setScigovFormErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={scigovTab.scigovSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {scigovTab.scigovSubmitting ? 'Updating...' : 'Update Setting'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Number Setting Form Modals */}
        {/* Ecourt Number Setting Form Modal */}
        {ecourtTab.showNumberSettingForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Add CNR Number</h3>
              </div>
              <form onSubmit={ecourtTab.handleAddNumberSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    CNR Number *
                  </label>
                  <input
                    type="text"
                    value={ecourtTab.newNumberSetting.cnr_number}
                    onChange={(e) => ecourtTab.setNewNumberSetting({...ecourtTab.newNumberSetting, cnr_number: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      ecourtTab.numberSettingErrors.cnr_number ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter CNR number"
                  />
                  {ecourtTab.numberSettingErrors.cnr_number && (
                    <p className="text-red-500 text-sm mt-1">{ecourtTab.numberSettingErrors.cnr_number}</p>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      ecourtTab.setShowNumberSettingForm(false);
                      ecourtTab.setNewNumberSetting({
                        scraperType: 'ecourtindia',
                        cnr_number: ''
                      });
                      ecourtTab.setNumberSettingErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={ecourtTab.numberSettingSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {ecourtTab.numberSettingSubmitting ? 'Adding...' : 'Add CNR Number'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Hcservices Number Setting Form Modal */}
        {hcservicesTab.showHcservicesNumberForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Add Hcservices CNR Number</h3>
              </div>
              <form onSubmit={hcservicesTab.handleAddHcservicesNumberSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    CNR Number *
                  </label>
                  <input
                    type="text"
                    value={hcservicesTab.newHcservicesNumberSetting.cnr_number}
                    onChange={(e) => hcservicesTab.setNewHcservicesNumberSetting({...hcservicesTab.newHcservicesNumberSetting, cnr_number: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      hcservicesTab.hcservicesNumberErrors.cnr_number ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter CNR number"
                  />
                  {hcservicesTab.hcservicesNumberErrors.cnr_number && (
                    <p className="text-red-500 text-sm mt-1">{hcservicesTab.hcservicesNumberErrors.cnr_number}</p>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      hcservicesTab.setShowHcservicesNumberForm(false);
                      hcservicesTab.setNewHcservicesNumberSetting({
                        scraperType: 'hcservices',
                        cnr_number: ''
                      });
                      hcservicesTab.setHcservicesNumberErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={hcservicesTab.hcservicesNumberSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {hcservicesTab.hcservicesNumberSubmitting ? 'Adding...' : 'Add CNR Number'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Scigov Number Setting Form Modal */}
        {scigovTab.showScigovNumberForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Add Scigov CNR Number</h3>
              </div>
              <form onSubmit={scigovTab.handleAddScigovNumberSetting} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    CNR Number *
                  </label>
                  <input
                    type="text"
                    value={scigovTab.newScigovNumberSetting.cnr_number}
                    onChange={(e) => scigovTab.setNewScigovNumberSetting({...scigovTab.newScigovNumberSetting, cnr_number: e.target.value})}
                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      scigovTab.scigovNumberErrors.cnr_number ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter CNR number"
                  />
                  {scigovTab.scigovNumberErrors.cnr_number && (
                    <p className="text-red-500 text-sm mt-1">{scigovTab.scigovNumberErrors.cnr_number}</p>
                  )}
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      scigovTab.setShowScigovNumberForm(false);
                      scigovTab.setNewScigovNumberSetting({
                        scraperType: 'scigov',
                        cnr_number: ''
                      });
                      scigovTab.setScigovNumberErrors({});
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={scigovTab.scigovNumberSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {scigovTab.scigovNumberSubmitting ? 'Adding...' : 'Add CNR Number'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">New Court Cases</h1>
        <p className="text-gray-600">Manage court case settings and scrape results</p>
      </div>

      {/* Main Tabs */}
      <div className="mb-6">
        <nav className="flex space-x-8">
          {mainTabs.map((tab, index) => (
            <button
              key={tab.key}
              onClick={() => {
                setSelectedTab(index);
                setSelectedSubTab(0);
              }}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                selectedTab === index
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      {/* Sub Tabs */}
      <div className="mb-6">
        <nav className="flex space-x-8">
          {subTabs.map((tab, index) => (
            <button
              key={tab.key}
              onClick={() => setSelectedSubTab(index)}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                selectedSubTab === index
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="bg-gray-50 rounded-lg p-6">
        {renderTabContent()}
      </div>

      {/* Modals */}
      {renderModals()}
    </div>
  );
};

export default NewCourtCases; 